import type { MutationTree } from 'vuex';
import type { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import type { AuthenticationStep } from '../../authentication/types/authentication-step';
import type { AuthenticationStepInput } from '../../authentication/types/authentication-step-input';
import type { Token } from '../type/token';
import { SessionMutation } from './session.types';
import type { SessionState } from './session.types';

export const mutations: MutationTree<SessionState> = {
  [SessionMutation.SetToken](state: SessionState, token: Token) {
    state.token.jwt = token.jwt;
    state.token.exp = token.exp;
    state.recipientFirstOpen = token.metaData ? token.metaData.isFirstVisit : true;
  },
  [SessionMutation.SetAuthenticationSteps](state: SessionState, steps: AuthenticationStep[]) {
    state.authentication.steps = steps;
  },
  [SessionMutation.SetError](state: SessionState, error: boolean) {
    state.error = error;
  },
  [SessionMutation.SetAuthenticationAnswers](
    state: SessionState,
    answers: AuthenticationStepInput[]
  ) {
    state.authentication.answers = answers;
  },
  [SessionMutation.SetStatus](state: SessionState, status: DocumentStatus) {
    state.status = status;
  },
  [SessionMutation.VerifySms](state: SessionState, verified: boolean) {
    state.isCorrectPin = verified;
  },
  [SessionMutation.SetSubmittingResponse](state: SessionState, submitting: boolean) {
    state.authentication.submittingResponse = submitting;
  },
  [SessionMutation.SetSendPinRetryCount](state: SessionState, retryCount: number) {
    state.sendPinRetryCount = retryCount;
  },
  [SessionMutation.SetRecipientFirstOpen](state: SessionState, value: boolean) {
    state.recipientFirstOpen = value;
  },
};
